import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, finalize, map, Observable, from, switchMap } from "rxjs";
import { Router } from "@angular/router";
import { CalService } from "../services/cal.service";
import { LoaderService } from "../services/loader.service";

export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    let preventLoader = false;
    if (req.method == 'POST' && req.url.includes('preventLoader=true')) {
        preventLoader = true;
    }
    if (req.body?.preventLoader || req.params?.get('preventLoader')) {
        preventLoader = true;
    }
    // check form data for preventLoader
    if (req.body instanceof FormData) {
        if (req.body?.get('preventLoader') == 'true') {
            preventLoader = true;
        }
    }

    let loaderService = inject(LoaderService);
    let calService = inject(CalService);
    let router = inject(Router);
    if (!preventLoader)
        loaderService.loadSpinner(true);
    let headers = {'Accept': 'application/json'}; 

    // Check if this is a PowerBI API call
    let isPowerBiApi = false;
    try {
        const urlObj = new URL(req.url, window.location.origin);
        isPowerBiApi = urlObj.hostname === 'api.powerbi.com';
    } catch (e) {
        isPowerBiApi = false;
    }

    // If it's a PowerBI API, skip token injection
    if (isPowerBiApi) {
        return next(req).pipe(
            map((event: HttpEvent<any>) => {
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                //router.navigate(['error']);
                throw (error);
            }),
            finalize(() => {
                // Hide loader when the request completes (success or error)
                if (!preventLoader)
                    loaderService.loadSpinner(false);
            })
        );
    }

    // Get token asynchronously and clone request with Authorization header
    return from(calService.getAADToken()).pipe(
        switchMap((tokenResult) => {
            // Extract token string from result (could be string, AuthenticationResult, or null)
            const token = typeof tokenResult === 'string' ? tokenResult : tokenResult?.accessToken || '';
            // console.log('HTTP Interceptor - Token retrieved:', token ? 'Token exists' : 'No token');
            req = req.clone({
                setHeaders: {
                    ...headers,
                    'Authorization': `Bearer ${token}`,
                }
            });
            return next(req);
        }),
        map((event: HttpEvent<any>) => {
            return event;
        }),
        catchError((error: HttpErrorResponse) => {
            //router.navigate(['error']);
            throw (error);
        }),
        finalize(() => {
            // Hide loader when the request completes (success or error)
            if (!preventLoader)
                loaderService.loadSpinner(false);
        })
    );
}
